import { useState } from 'react'

import { addDays, endOfWeek, isAfter, isBefore, parseISO, startOfWeek } from 'date-fns'

import type { TournamentCalendar, TournamentWeek } from '../types/storeTypes/soccerDataStoreTypes'

export const useMatchesNavigation = (tournamentCalendar: TournamentCalendar, selectedWeek?: TournamentWeek) => {
  const today = new Date()
  const start = startOfWeek(today)
  const end = endOfWeek(today)

  const [week, setWeek] = useState(selectedWeek || { start, end })
  const calStart = parseISO(tournamentCalendar?.startDate || '')
  const calEnd = parseISO(tournamentCalendar?.endDate || '')

  const isNotStarted = Boolean(tournamentCalendar?.startDate && isBefore(today, calStart))
  const isFinished = Boolean(tournamentCalendar?.endDate && isAfter(today, calEnd))

  const prevDisabled = tournamentCalendar?.startDate && isBefore(week.start, calStart)
  const nextDisabled = tournamentCalendar?.endDate && isAfter(week.end, calEnd)

  const calculateWeek = (backward = false) => {
    setWeek((prev) => ({
      start: addDays(prev.start, backward ? -7 : 7),
      end: addDays(prev.end, backward ? -7 : 7),
    }))
  }
  const onNextWeek = () => !nextDisabled && calculateWeek()
  const onPrevWeek = () => !prevDisabled && calculateWeek(true)

  const setWeekOnDate = (dateString: string) => {
    const date = parseISO(dateString)
    setWeek({
      start: startOfWeek(date),
      end: endOfWeek(date),
    })
  }

  const resetWeek = () => {
    setWeek({ start, end })
  }

  return {
    week,
    weekInRange: isAfter(week.end, calStart) && isBefore(week.start, calEnd),
    onNextWeek,
    onPrevWeek,
    setWeekOnDate,
    resetWeek,
    prevDisabled: !!prevDisabled,
    nextDisabled: !!nextDisabled,
    isFinished,
    isNotStarted,
  }
}
